import React from "react"
import ReactDOM from "react-dom"
import "./styles/main.scss"
import App from "./App"
import "bootstrap/dist/css/bootstrap.css";

ReactDOM.render( <App />, document.getElementById("root"))
